// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeePlanCodeDto
 */
export interface IEmployeePlanCodeDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeePlanCodeDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeePlanCodeDto
     */
    plan_code?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeePlanCodeDto
     */
    contribution_date?: Date;
}

/**
 * Check if a given object implements the IEmployeePlanCodeDto interface.
 */
export function instanceOfIEmployeePlanCodeDto(value: object): value is IEmployeePlanCodeDto {
    return true;
}

export function IEmployeePlanCodeDtoFromJSON(json: any): IEmployeePlanCodeDto {
    return IEmployeePlanCodeDtoFromJSONTyped(json, false);
}

export function IEmployeePlanCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeePlanCodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'contribution_date': json['contribution_date'] == null ? undefined : (new Date(json['contribution_date'])),
    };
}

export function IEmployeePlanCodeDtoToJSON(json: any): IEmployeePlanCodeDto {
    return IEmployeePlanCodeDtoToJSONTyped(json, false);
}

export function IEmployeePlanCodeDtoToJSONTyped(value?: IEmployeePlanCodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'plan_code': value['plan_code'],
        'contribution_date': value['contribution_date'] == null ? undefined : ((value['contribution_date']).toISOString().substring(0,10)),
    };
}

